export const CREATE_PRODUCT ='CREATE_PRODUCT';
export const UPDATE_PRODUCT ='UPDATE_PRODUCT';
export const DELETE_PRODUCT ='DELETE_PRODUCT';
export const READ_PRODUCT ='READ_PRODUCT';
export const LOAD_PRODUCT_SUCCESS = 'LOAD_PRODUCT_SUCCESS';
export const GET_PRODUCT_BY_QUANTITY = 'GET_PRODUCT_BY_QUANTITY';
export const GET_PRODUCT_BY_NAME = 'GET_PRODUCT_BY_NAME';
